import { findNearestExchangeRate } from './currency.js';

export const accountTypes = [
    { id: 'assetaccounts', name: 'Asset' },
    { id: 'liabilityaccounts', name: 'Liability' },
    { id: 'equityaccounts', name: 'Equity' },
    { id: 'incomeaccounts', name: 'Income' },
    { id: 'expenseaccounts', name: 'Expense' },
];

export const groupTypes = [
    { id: 'assetgroups', name: 'Asset' },
    { id: 'liabilitygroups', name: 'Liability' },
    { id: 'equitygroups', name: 'Equity' },
    { id: 'incomegroups', name: 'Income' },
    { id: 'expensegroups', name: 'Expense' },
];

export function getChartAccounts(context) {
    const {
        assetgroups,
        assetaccounts,
        liabilitygroups,
        liabilityaccounts,
        equitygroups,
        equityaccounts,
        incomegroups,
        incomeaccounts,
        expensegroups,
        expenseaccounts,
        currencies
    } = context;

    const resultArray = [];

    resultArray.push({
        name: "Assets",
        type: 'title'
    });

    assetgroups.sort((a, b) => a.orderid - b.orderid);
    assetgroups.forEach(group => {
        resultArray.push({
            id: group.id,
            orderid: group.orderid,
            name: group.name,
            type: 'assetgroups'
        });

        const groupAccounts = assetaccounts.filter(account => account.groupid === group.id);
        groupAccounts.sort((a, b) => a.orderid - b.orderid);
        groupAccounts.forEach(account => {
            const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
            resultArray.push({
                id: account.id,
                orderid: account.orderid,
                groupid: account.groupid,
                name: account.name,
                currencyid: account.currencyid,
                currencysymbol: currencySymbol,
                budget: account.budget,
                type: 'assetaccounts'
            });
        });
    });

    const ungroupedAssetAccounts = assetaccounts.filter(account => !account.groupid);
    ungroupedAssetAccounts.sort((a, b) => a.orderid - b.orderid);
    ungroupedAssetAccounts.forEach(account => {
        const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
        resultArray.push({
            id: account.id,
            orderid: account.orderid,
            groupid: account.groupid,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencySymbol,
            budget: account.budget,
            type: 'assetaccounts'
        });
    });

    resultArray.push({
        name: "Liabilities",
        type: 'title'
    });

    liabilitygroups.sort((a, b) => a.orderid - b.orderid);
    liabilitygroups.forEach(group => {
        resultArray.push({
            id: group.id,
            orderid: group.orderid,
            name: group.name,
            type: 'liabilitygroups'
        });

        const groupAccounts = liabilityaccounts.filter(account => account.groupid === group.id);
        groupAccounts.sort((a, b) => a.orderid - b.orderid);
        groupAccounts.forEach(account => {
            const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
            resultArray.push({
                id: account.id,
                orderid: account.orderid,
                groupid: account.groupid,
                name: account.name,
                currencyid: account.currencyid,
                currencysymbol: currencySymbol,
                budget: account.budget,
                type: 'liabilityaccounts'
            });
        });
    });

    const ungroupedLiabilityAccounts = liabilityaccounts.filter(account => !account.groupid);
    ungroupedLiabilityAccounts.sort((a, b) => a.orderid - b.orderid);
    ungroupedLiabilityAccounts.forEach(account => {
        const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
        resultArray.push({
            id: account.id,
            orderid: account.orderid,
            groupid: account.groupid,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencySymbol,
            budget: account.budget,
            type: 'liabilityaccounts'
        });
    });

    resultArray.push({
        name: "Equity",
        type: 'title'
    });

    equitygroups.sort((a, b) => a.orderid - b.orderid);
    equitygroups.forEach(group => {
        resultArray.push({
            id: group.id,
            orderid: group.orderid,
            name: group.name,
            type: 'equitygroups'
        });

        const groupAccounts = equityaccounts.filter(account => account.groupid === group.id);
        groupAccounts.sort((a, b) => a.orderid - b.orderid);
        groupAccounts.forEach(account => {
            const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
            resultArray.push({
                id: account.id,
                orderid: account.orderid,
                groupid: account.groupid,
                name: account.name,
                currencyid: account.currencyid,
                currencysymbol: currencySymbol,
                budget: account.budget,
                type: 'equityaccounts'
            });
        });
    });

    const ungroupedEquityAccounts = equityaccounts.filter(account => !account.groupid);
    ungroupedEquityAccounts.sort((a, b) => a.orderid - b.orderid);
    ungroupedEquityAccounts.forEach(account => {
        const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
        resultArray.push({
            id: account.id,
            orderid: account.orderid,
            groupid: account.groupid,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencySymbol,
            budget: account.budget,
            type: 'equityaccounts'
        });
    });

    resultArray.push({
        name: "Income",
        currency: '',
        amount: '',
        type: 'title'
    });

    incomegroups.sort((a, b) => a.orderid - b.orderid);
    incomegroups.forEach(group => {
        resultArray.push({
            id: group.id,
            orderid: group.orderid,
            name: group.name,
            type: 'incomegroups'
        });

        const groupAccounts = incomeaccounts.filter(account => account.groupid === group.id);
        groupAccounts.sort((a, b) => a.orderid - b.orderid);
        groupAccounts.forEach(account => {
            const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
            resultArray.push({
                id: account.id,
                orderid: account.orderid,
                groupid: account.groupid,
                name: account.name,
                currencyid: account.currencyid,
                currencysymbol: currencySymbol,
                budget: account.budget,
                type: 'incomeaccounts'
            });
        });
    });

    const ungroupedIncomeAccounts = incomeaccounts.filter(account => !account.groupid);
    ungroupedIncomeAccounts.sort((a, b) => a.orderid - b.orderid);
    ungroupedIncomeAccounts.forEach(account => {
        const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
        resultArray.push({
            id: account.id,
            orderid: account.orderid,
            groupid: account.groupid,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencySymbol,
            budget: account.budget,
            type: 'incomeaccounts'
        });
    });

    resultArray.push({
        name: "Expense",
        type: 'title'
    });

    expensegroups.sort((a, b) => a.orderid - b.orderid);
    expensegroups.forEach(group => {
        resultArray.push({
            id: group.id,
            orderid: group.orderid,
            name: group.name,
            type: 'expensegroups'
        });

        const groupAccounts = expenseaccounts.filter(account => account.groupid === group.id);
        groupAccounts.sort((a, b) => a.orderid - b.orderid);
        groupAccounts.forEach(account => {
            const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
            resultArray.push({
                id: account.id,
                orderid: account.orderid,
                groupid: account.groupid,
                name: account.name,
                currencyid: account.currencyid,
                currencysymbol: currencySymbol,
                budget: account.budget,
                type: 'expenseaccounts'
            });
        });
    });

    const ungroupedExpenseAccounts = expenseaccounts.filter(account => !account.groupid);
    ungroupedExpenseAccounts.sort((a, b) => a.orderid - b.orderid);
    ungroupedExpenseAccounts.forEach(account => {
        const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
        resultArray.push({
            id: account.id,
            orderid: account.orderid,
            groupid: account.groupid,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencySymbol,
            budget: account.budget,
            type: 'expenseaccounts'
        });
    });

    return resultArray;
}

export function getExpenseBudget(context) {
    const {
        expensegroups,
        expenseaccounts,
        currencies,
        exchangerates,
        currencyid,
    } = context;

    const baseCurrencySymbol = currencies.find((currency) => currency.id === currencyid)?.symbol;

    const resultArray = [];
    let totalbudget = 0;

    const sortedExpenseGroups = [...expensegroups].sort((a, b) => a.orderid - b.orderid);
    sortedExpenseGroups.forEach(group => {
        resultArray.push({
            id: group.id,
            orderid: group.orderid,
            name: group.name,
            currency: '',
            amount: '',
            type: 'expensegroup'
        });

        const groupAccounts = [...expenseaccounts].filter(account => account.groupid === group.id);
        const sortedGroupAccounts = groupAccounts.sort((a, b) => a.orderid - b.orderid);

        sortedGroupAccounts.forEach(account => {
            const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;

            if (account.currencyid != currencyid) {
                const NearestExchangeRate = findNearestExchangeRate(exchangerates, 0, account.currencyid, currencyid);
                const exchangerate = NearestExchangeRate.exchangerate;
                totalbudget = totalbudget + parseFloat(account.budget) * exchangerate
            }
            else {
                totalbudget = totalbudget + parseFloat(account.budget)
            }

            resultArray.push({
                id: account.id,
                orderid: account.orderid,
                name: account.name,
                currencyid: account.currencyid,
                currencysymbol: currencySymbol,
                budget: account.budget,
                type: 'expenseaccount'
            });
        });
    });

    const ungroupedExpenseAccounts = [...expenseaccounts].filter(account => !account.groupid);
    const sortedUngroupedAccounts = ungroupedExpenseAccounts.sort((a, b) => a.orderid - b.orderid);

    sortedUngroupedAccounts.forEach(account => {
        const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;
        if (account.currencyid != currencyid) {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, 0, account.currencyid, currencyid);
            const exchangerate = NearestExchangeRate.exchangerate;
            totalbudget = totalbudget + parseFloat(account.budget) * exchangerate
        }
        else {
            totalbudget = totalbudget + parseFloat(account.budget)
        }

        resultArray.push({
            id: account.id,
            orderid: account.orderid,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencySymbol,
            budget: account.budget,
            type: 'expenseaccount'
        });
    });

    resultArray.push({
        id: '',
        orderid: '',
        name: 'Total budget',
        currencysymbol: baseCurrencySymbol,
        budget: totalbudget,
        type: 'expensetotal'
    });

    return resultArray;
}
